module.exports = __webpack_public_path__ + "img/signup-thumb.f7b51fb4.png";